import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledCopyableButton = styled('div')`
  cursor: pointer;

  .copy {
    color: ${(props) =>
      props.defaultColor ? props.defaultColor : COLOR.indigo[80]};
  }

  .check {
    color: ${COLOR.success} !important;
  }
`;
